import { create } from 'zustand';

const useLoadingStore = create((set) => ({
  isLoading: false,
  loadingMessage: '',

  startLoading: (message = '') => {
    set({ isLoading: true, loadingMessage: message });
  },

  stopLoading: () => {
    set({ isLoading: false, loadingMessage: '' });
  },
}));

export default useLoadingStore;
